import React from 'react';
import './LegalPage.css';

const TermsPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src="/rally-font.svg" alt="Rally" className="legal-logo" />
        </div>

        <div className="legal-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using the Rally mobile application ("App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Rally is a mobile application that allows marathon runners to receive voice messages from friends and family at specific mile markers during races. The service includes:
            </p>
            <ul>
              <li>Race selection and registration</li>
              <li>Voice message recording and storage</li>
              <li>Location-based message playback</li>
              <li>Social sharing features</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              You must create an account using Apple Sign-in to use certain features of the App. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2>4. User Content</h2>
            <p>
              You retain ownership of voice messages and other content you submit through the App. By submitting content, you grant Rally a worldwide, royalty-free license to use, store, and transmit your content for the purpose of providing the service.
            </p>
          </section>

          <section>
            <h2>5. Privacy and Location Data</h2>
            <p>
              Rally collects location data to provide location-based message playback during races. Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and protect your information.
            </p>
          </section>

          <section>
            <h2>6. Prohibited Uses</h2>
            <p>You agree not to use the App to:</p>
            <ul>
              <li>Record or share inappropriate, offensive, or harmful content</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Interfere with or disrupt the service</li>
              <li>Attempt to gain unauthorized access to the service</li>
            </ul>
          </section>

          <section>
            <h2>7. Service Availability</h2>
            <p>
              Rally strives to maintain service availability but does not guarantee uninterrupted access. We may temporarily suspend the service for maintenance or updates.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              Rally provides the service "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the App.
            </p>
          </section>

          <section>
            <h2>9. Changes to Terms</h2>
            <p>
              Rally reserves the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the App constitutes acceptance of any changes.
            </p>
          </section>

          <section>
            <h2>10. Contact Information</h2>
            <p>
              If you have questions about these Terms, please contact us at:
              <br />
              Email: hello@wimlabs.dev
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/">← Back to Rally</a>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;